<template>
	<div class="PayInfoWrap">
		<!-- 头部 -->
		<div class="topHeaderWrap"><TopHeader /></div>
		<!-- mobile 返回 -->
		<div class="topPart">
			<div class="return" @click="PayErrorReturn"></div>
			<a href="https://m.tunnelling.cn/Manager/MemberIndex.aspx"><img :src="imgUrl" alt="" /></a>
		</div>
		<!-- 支付失败 -->
		<div class="PayError">
			<div class="PayInfoBox">
				<img src="../../assets/img/payError_icon.svg" alt="" />
				<p class="payState">支付失败，请重新付款</p>
				<p class="explain">支付失败！请检查网络是否正常，请重新进行支付</p>
				<router-link v-if="InformationId" :to="{path:'/bookDetail', query:{InformationId:InformationId}}">回到图书</router-link>
				<router-link v-else to="/index">回到书库</router-link>
				<!-- 更多情报 -->
				<MoreNews />
			</div>
		</div>
		<!-- 页脚 -->
		<BottomFooter />
	</div>
</template>

<script>
import TopHeader from '../../components/TopHeader.vue'
import MoreNews from '../../components/MoreNews.vue'
import BottomFooter from '../../components/BottomFooter.vue'
export default{
	name: 'PayError',
	data(){
		return{
			InformationId:undefined,  // 情报id
			imgUrl:'',  // 头像
		}
	},
	mounted() {
		this.GetUserInfo();
        this.InformationId = this.getQueryString('informationId')?this.getQueryString('informationId'):sessionStorage.getItem('informationId');
	},
	methods:{
		// 获取用户信息
		GetUserInfo(){
			this.$fetch('/Login')
			.then((res)=>{
				if(res.data.accessAllowed === false) return;
				this.imgUrl = res.data.imagePath;
			}).catch((err)=>{
				throw err;
			});
		},
        // 获取url参数
        getQueryString (name){
        	var url = location.href;
        	var params = url.split('?');
        	var paramsArr = params[1].split('&');
        	for(var i=0;i<paramsArr.length;i++){
        		var paramsVal = paramsArr[i].split('=');
        		if(paramsVal[0]==name) return paramsVal[1];
        	}
        	return false;
        },
		// 返回
		PayErrorReturn(){
			this.$router.go(-1);
		}
	},
	components:{
		TopHeader,
		MoreNews,
		BottomFooter
	}
}
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
	.topHeaderWrap{
		display: none;
	}
	.topPart{
		width: 100%;
		height: .88rem;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		position: relative;
	}
	.topPart img{
		width: .6rem;
		height: .6rem;
		border-radius: 50%;
		margin-right: .25rem;
	}
	.topPart .return{
		width: .4rem;
		height: .4rem;
		background: url(../../assets/img/return_mobile.svg) no-repeat;
		background-size: 100% 100%;
		position: absolute;
		left: .25rem;
		top: 50%;
		transform: translateY(-50%);
	}
	.topInfo{
		border-bottom: 1px solid #EEEEEE;
	}
	.PayInfoBox{
		text-align: center;
	}
	.PayInfoBox .explain{
		width: 4.9rem;
	}
	.PayInfo{
		width: 100%;
		margin: .5rem 0 .4rem;
		padding: .4rem .5rem;
	}
	/* 去阅读+回到书库 */
	.btnWrap{
		margin: 0 0 .64rem;
	}
	.btnWrap a,.PayError a{
		width: 100%;
		display: block;
		line-height: .98rem;
		font-size: .36rem;
		border-radius: 4px;
		text-align: center;
	}
	.btnWrap a:first-child,.PayError a{
		color: #FFFFFF;
		background: #2468F2;
	}
	.btnWrap a:last-child{
		background: #F2F2F2;
		color: #333333;
		margin-top: .24rem;
	}
	.PayError{
		padding: 0 .25rem;
	}
	.PayError a{
		margin: 4rem auto .68rem;
	}
}
@media screen and (min-width: 1029px) {
	.topPart{
		display: none;
	}
	.PayInfoBox{
		width: 1200px;
		margin: 0 auto;
		background: #FFFFFF;
		margin-top: 23px;
		text-align: center;
	}
	.PayInfoBox img{
		margin-top: 64px;
	}
	.PayInfoBox .explain{
		width: 480px;
	}
	.PayInfo{
		width: 560px;
		margin: 0 auto;
		padding: 24px 88px;
	}
	/* 去阅读+回到书库 */
	.btnWrap{
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 30px 0 74px;
	}
	.btnWrap a:first-child,.PayError a{
		width: 176px;
		line-height: 40px;
		background: #2468F2;
		border-radius: 4px;
		font-size: 14px;
		color: #FFFFFF;
		letter-spacing: 0;
		margin-right: 20px;
	}
	.btnWrap a:last-child{
		width: 127px;
		line-height: 40px;
		background: #F2F2F2;
		border-radius: 4px;
		font-size: 16px;
		color: #424242;
		letter-spacing: 0.69px;
	}
	.PayError a{
		display: block;
		margin: 52px auto 74px;
	}
}
.PayInfoWrap{
	width: 100%;
}
.PayInfoBox>img{
	margin: 64px 0 24px;
}
.PayInfoBox .payState{
	font-size: 24px;
	color: #333333;
	line-height: 32px;
}
.PayInfoBox .explain{
	font-size: 14px;
	color: rgba(0,0,0,0.45);
	text-align: center;
	line-height: 22px;
	margin: 16px auto 24px;
}
/* 订单信息 */
.PayInfo{
	background: rgba(245,245,245,0.50);
	border-radius: 2px;
	box-sizing: border-box;
	text-align: left;
}
.PayInfo p{
	margin-top: 24px;
	font-size: 14px;
	color: #333333;
	line-height: 22px;
}
.PayInfo p:first-child{
	margin-top: 0;
}
.PayInfo p>span{
	color: #666666;
	margin-right: 14px;
	font-size: 14px;
}
.PayInfo strong{
	font-size: 20px;
	line-height: 28px;
}
.PayInfo p:last-child{
	font-size: 12px;
	color: #333333;
	line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Payment/PayError.vue